import { render, staticRenderFns } from "./arecievec.vue?vue&type=template&id=be781680&scoped=true&"
import script from "./arecievec.vue?vue&type=script&lang=js&"
export * from "./arecievec.vue?vue&type=script&lang=js&"
import style0 from "./arecievec.vue?vue&type=style&index=0&id=be781680&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be781680",
  null
  
)

export default component.exports